import React from 'react';
import SideMenu from '@v2/shared/Layouts/SideMenu';
import { accountMenu } from '@v2/shared/Layouts/Account/menu';
import { AccountLayoutProps } from '@v2/shared/lib/types';
import Full from '../Full';

/**
 * The shell the signed-in customer's pages share, in TopMags' chrome.
 *
 * DiscountMags' Account layout's counterpart: the same name, the same props and the same
 * rail, resolved by brand exactly as `Layouts.Full` is. A page declares
 * `layoutName = 'Layouts.Account'` and gets its own brand's version without knowing
 * which brand it is on.
 *
 * No Container here, and none in DiscountMags' either: every brand's Full draws it now,
 * along with the standard padding inside it, so a layout over Full never has to ask
 * whether it has been boxed or spaced already. What is left for a brand to say is what it
 * actually disagrees about — here, that TopMags puts the rail on a white card and that it
 * has no digital library.
 */
export default function Account({
  children,
  autoRenewServiceName,
  autoRenewUrl,
  activePath,
  ...fullProps
}: AccountLayoutProps) {
  return (
    <Full {...fullProps}>
      {/* No digital library: TopMags has never had one, and its legacy account pages
          already leave the entry out. See accountMenu. */}
      <SideMenu
        label="Account"
        groups={accountMenu({ autoRenewServiceName, autoRenewUrl })}
        activePath={activePath}
      >
        {children}
      </SideMenu>
    </Full>
  );
}
